import {rowErrorColor, rowWarningColor} from "../../views/theme";

export enum ReviewProblemLevel {
    ERROR = "ERROR",
    WARNING = "WARNING"
}

export interface InvoiceReviewProblem {
    level: ReviewProblemLevel;
    category: string;
    description: string;
}

export const getColorForLevel = (level: ReviewProblemLevel) => {
    if (level === ReviewProblemLevel.WARNING) {
        return rowWarningColor;
    } else {
        return rowErrorColor;
    }
}
